<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiPlus } from "@mdi/js";
export default {
  name: "MdiPlus",
  data() {
    return {
      svgPath: mdiPlus,
    };
  },
};
</script>
